





































import * as notificationAPI from '@adobe/edex/frontend/api/notification';
import { mapState } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { isEmpty } from 'lodash-es';

enum TemplateNames {
  passed = 'Course Passed',
  enrolled = 'Course Enrollment Confirmation',
  firstReminder = 'Course First Reminder',
  secondReminder = 'Course Second Reminder',
  lastReminder = 'Course Last Reminder',
}

const getInitialState = () => ({
  subject: '',
  richText: '',
  plainText: '',
  loading: false,
  error: false,
  hasInitialData: false,
  thresholdDay: -1,
  thresholdError: false,
});

export default {
  props: {
    templateName: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
    },
    thresholdDay: {
      type: Number,
    },
    thresholdError: {
      type: Boolean,
    },
  },
  data() {
    return getInitialState();
  },
  mixins: [validationMixin],
  validations: {
    templateName: { required },
    subject: { required },
    richText: { required },
    plainText: { required },
  },
  computed: {
    ...mapState('course', ['course']),
    isUpdateForm() {
      return Boolean(this.data);
    },
    disableDelete() {
      return isEmpty(this.data);
    },
    title() {
      switch (this.templateName) {
        case TemplateNames.passed:
          return 'Course Completion Email Template';
        case TemplateNames.enrolled:
          return 'Course Enrollment Confirmation Email Template';
        case TemplateNames.firstReminder:
          return 'First Reminder Email Template';
        case TemplateNames.secondReminder:
          return 'Second Reminder Email Template';
        case TemplateNames.lastReminder:
          return 'Last Reminder Email Template';
        default:
          return '';
      }
    },
    buttonText() {
      return this.isUpdateForm ? 'Update' : 'Create';
    },
    showDelete() {
      return (
        this.templateName === TemplateNames.firstReminder ||
        this.templateName === TemplateNames.secondReminder ||
        this.templateName === TemplateNames.lastReminder
      );
    },
  },
  methods: {
    isValid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    async submit() {
      if (this.isValid() && !this.thresholdError) {
        const { templateName, subject, richText, plainText, thresholdDay } = this;

        const payload = {
          templateName,
          subject,
          richText,
          plainText,
          thresholdDay,
          entityType: 'course',
          entityID: this.course.id,
        };

        this.error = false;
        this.loading = true;

        try {
          if (this.isUpdateForm) {
            await this.createTemplate(templateName, payload);
          } else {
            await this.updateTemplate(templateName, payload);
          }

          this.error = false;
          this.loading = false;
        } catch (error) {
          this.error = true;
          this.loading = false;
        }
      }
    },
    async createTemplate(name, payload) {
      const { data } = await notificationAPI.update(this.data.id, payload);

      this.$emit('onSubmitSuccess', {
        data,
        name,
      });
    },
    async updateTemplate(name, payload) {
      const { data } = await notificationAPI.create(payload);

      this.$emit('onSubmitSuccess', {
        data,
        name,
      });
    },
    async handleDelete(event) {
      event.preventDefault();
      await notificationAPI.remove(this.data.id);
      this.$emit('onSubmitSuccess', {
        data: null,
        name: this.templateName,
      });
    },
  },
  watch: {
    data(current, previous) {
      if (!current) {
        this.subject = '';
        this.richText = '';
        this.plainText = '';
      }
      if (current && current !== previous) {
        this.subject = current.subject;
        this.richText = current.richText;
        this.plainText = current.plainText;
      }
    },
  },
};
